
<div class="ui-g-12" *ngIf="show.datatable && srvCalTranslate && srvCalTranslate.pcalendarTranslate && srvCalTranslate.pcalendarTranslate.dateFormatFilter">

  <app-kontable *ngIf="hideCustomerInfoPermission"
    #tablePT
    title = "{{ 'customers.customers_card_search' | translate }}"
    [columns] = "[
         {field: 'card_no', title: 'customers.card_no', maxFilterChars: maxChars},
         'divisionSalesNetwork',
         'channelCode',
         'store',
         {field: 'customerDescription', title: 'loyalty.customerDescription', filterType: noFilter },
         { field: 'birth_date', title: 'common.birth_date', type: 'date', filterType: dateFilter },
         { field: 'flg_blk_lst', title: 'loyalty.blacklist', filterType: selectFilter, filterOptions: { values: blackListType },bodyTemplate: blacklistTemplate}
    ]"
    [titles] = "[
         'loyalty.divisionSalesNetwork',
         'loyalty.channelCode',
         'loyalty.storeDescription',
         'loyalty.customerDescription'
    ]"
    [showDetailsButton]="false"
    [showInfoButton]="false"
    [showEditButton]="false"
    [showGlobalFilter]="false"
    [showRecoverButton]="false"
    [showDeleteButton]="false"
    [showReport]="false"
    [paginationType]="paginationType"
    [service]="svcCard"
    [fixedFilters]="initialFilters"
    [additionalRowCommands]="customActions"
    [filterBySingleColumn]="false">


    <ng-template #blacklistTemplate data-testid="blackListTemplate" let-row>
      <span *ngIf="row.flg_blk_lst === '1'">
        {{'report.inBlacklist' | translate}}
      </span>
   
      <span *ngIf="row.flg_blk_lst === '0'">
        {{'report.active' | translate }}
      </span>
  </ng-template>

    <ng-template #customActions data-testid="customActions" let-row>
      <p-button pTooltip="{{ 'common.select' | translate }}" icon="fa fas fa-arrow-circle-right"  styleClass="ui-button-info" (onClick)="_onCardSelect(row)"></p-button>
    </ng-template>

  </app-kontable>

  <app-kontable *ngIf="!hideCustomerInfoPermission"
    #tablePT
    title = "{{ 'customers.customers_card_search' | translate }}"
    [columns] = "[
         {field: 'card_no', title: 'customers.card_no', maxFilterChars: maxChars},
         'divisionSalesNetwork',
         'channelCode',
         'store',
         'customerDescription',
         { field: 'birth_date', title: 'common.birth_date', type: 'date', filterType: dateFilter },
         { field: 'flg_blk_lst', title: 'loyalty.blacklist',filterType: selectFilter, filterOptions: { values: blackListType },bodyTemplate: blacklistTemplate}
    ]"
    [titles] = "[
         'loyalty.divisionSalesNetwork',
         'loyalty.channelCode',
         'loyalty.storeDescription',
         'loyalty.customerDescription'
    ]"
    [showDetailsButton]="false"
    [showInfoButton]="false"
    [showEditButton]="false"
    [showGlobalFilter]="false"
    [showRecoverButton]="false"
    [showDeleteButton]="false"
    [showReport]="false"
    [paginationType]="paginationType"
    [service]="svcCard"
    [fixedFilters]="initialFilters"
    [additionalRowCommands]="customActions"
    [filterBySingleColumn]="false">


    <ng-template #blacklistTemplate data-testid="blackListTemplate" let-row>
      <span *ngIf="row.flg_blk_lst === '1'">
        {{'report.inBlacklist' | translate}}
      </span>
   
      <span *ngIf="row.flg_blk_lst === '0'">
        {{'report.active' | translate }}
      </span>
  </ng-template>


    <ng-template #customActions data-testid="customActions" let-row>
      <p-button pTooltip="{{ 'common.select' | translate }}" icon="fa fas fa-arrow-circle-right"  styleClass="ui-button-info" (onClick)="_onCardSelect(row)"></p-button>
    </ng-template>

  </app-kontable>

</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/widget/customer-card-search/card-selection-table/card-selection-table.component.html